module.exports = __webpack_public_path__ + "img/no_data@2.1154e37d.png";